import { render } from "./TrayPanelSpecies.vue?vue&type=template&id=09e533c2&scoped=true"
import script from "./TrayPanelSpecies.vue?vue&type=script&lang=js"
export * from "./TrayPanelSpecies.vue?vue&type=script&lang=js"

import "./TrayPanelSpecies.vue?vue&type=style&index=0&id=09e533c2&lang=scss&scoped=true"
import "./TrayPanelSpecies.vue?vue&type=style&index=1&id=09e533c2&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e533c2"]])

export default __exports__